import React from "react";

export const Logomark: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    width="40"
    height="24"
    viewBox="0 0 40 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M30.391 0.810547H21.603V5.34592H30.391C31.0033 5.34592 31.5899 5.45477 32.1341 5.65433L21.603 16.6345V10.4165C21.6045 5.12067 17.2944 0.810547 11.9956 0.810547H3.2075V5.34592H11.9956C12.6078 5.34592 13.1944 5.45477 13.7387 5.65433L0 19.981L3.20902 23.1881L16.8545 8.95911C16.9935 9.42172 17.0691 9.91154 17.0691 10.418V23.1881H21.6045L35.2499 8.95911C35.389 9.42172 35.4646 9.91154 35.4646 10.418V23.1881H40V10.418C40 5.12067 35.6899 0.810547 30.3926 0.810547H30.391Z"
      fill="#FF5C45"
    />
  </svg>
);
